const userInfoKey = "hans_user_info"
const tokenKey = 'hans_user_token'
const tokenExporeTimeKey = 'hans_user_TOKEN_EXPORE_TIME'
  export function  saveUserInfo(data) {
    localStorage.setItem(userInfoKey, JSON.stringify(data))
  }
  export function  getUserInfo() {
    var val = localStorage.getItem(userInfoKey);
      val = JSON.parse(val);
      return val
  }
  export function clearUserInfo(){
    localStorage.removeItem(userInfoKey)
  }
  export function saveLoginToken(token){
    localStorage.setItem(tokenKey,token)
  }
  export function  getLoginToken(){
    var val = localStorage.getItem(tokenKey)
    return val
  }

  export function saveTokenExpireTime(time){
    localStorage.setItem(tokenExporeTimeKey,time)
  }

  export function getTokenExpireTime(){
    var time = localStorage.getItem(tokenExporeTimeKey)
    return time
  }
  export function  clearToken(){
    localStorage.removeItem(tokenKey)
  }
  export function  clearAll(){
    localStorage.removeItem(userInfoKey)
    localStorage.removeItem(tokenKey)
  }


// WEBPACK FOOTER //
// ./src/store/localstore.js